import * as React from 'react';

import noop from 'helper/noop';
import { delayed } from 'lib/Job';

import Knob from 'components/atoms/Knob';
import { KnobProps } from 'components/atoms/Knob';

export type InputGroupProps = {
	state?: string;
	id?: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	value: string;
	actionKnob?: KnobProps & {
		callback: Function;
	};
	onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	name?: string;
	text?: string;
	label: string;
	placeholder?: string;
	unit?: string;
	message?: string;
	suffix?: string;
	isValidating?: boolean;
	modifier?: string;
};

export default function InputGroup(props: InputGroupProps) {
	const {
		state,
		id,
		onChange,
		value,
		onFocus = noop,
		onBlur = noop,
		name,
		actionKnob,
		text,
		label,
		placeholder,
		message,
		suffix,
		isValidating = false,
		modifier,
	} = props;

	const classNames = ((mod?: string, st?: string): string => {
		const classes = ['m-input-group'];

		if (mod) {
			classes.push(`m-input-group--${mod}`);
		}

		if (st) {
			classes.push(`state-m-input-group--${st}`);
		}

		return classes.join(' ');
	})(modifier, state);

	const Label = id
		? () => (
				<label className="m-input-group__label" htmlFor={id}>
					{label}
				</label>
		  )
		: () => null;

	return (
		<div className={classNames}>
			{actionKnob ? (
				<div className="m-input-group__head">
					{' '}
					<Label />
					<div className="m-input-group__button">
						<Knob
							modifier={actionKnob.modifier || 'filled-white'}
							size={actionKnob.size || 'xs'}
							icon={actionKnob.icon || 'question-mark'}
							onClick={() => {
								delayed(() => {
									actionKnob.callback();
								}, 100);
							}}
						/>
					</div>
				</div>
			) : (
				<Label />
			)}
			{text && <p className="m-input-group__text">{text}</p>}
			<div className="m-input-group__wrap">
				<input
					className="a-input"
					type="text"
					id={id}
					value={value}
					onChange={onChange}
					onFocus={onFocus}
					onBlur={onBlur}
					name={name}
					placeholder={placeholder}
				/>
				{message && !isValidating && <div className="m-input-group__message">{message}</div>}
			</div>
			{suffix && <span className="m-input-group__suffix">{suffix}</span>}
		</div>
	);
}
